import { Box, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useCurrencyFormatter } from '@/hooks';

interface PriceProps {
  price: number;
}

export const Price = ({ price }: PriceProps) => {
  const { t } = useTranslation();
  const currencyFormatter = useCurrencyFormatter();
  const monthlyPrice = price / 12;

  return (
    <Box textAlign="right" flexShrink={0}>
      <Text fontSize="lg" fontWeight="bold">
        {currencyFormatter.format(monthlyPrice)}
        {t('price.perMonth')}
      </Text>
      <Text fontSize="sm" color="neutral.400">
        {currencyFormatter.format(price)}
        {t('price.perYear')}
      </Text>
    </Box>
  );
};
